import React from "react"
import { browserHistory } from "react-router"
import Menu from "material-ui/Menu"
import MenuItem from "material-ui/MenuItem"
import strings from "../../localization/strings"

import AppStateStore from "../../stores/AppStateStore"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"
import accountStore from "../../stores/AccountStore"
interface IProps {
    navItems: string[]
    selectedItem: string
}

const HierarchyLeftNav: React.SFC<IProps> = (props: IProps) => {
    
    let selectedItem = props.selectedItem
    if (!selectedItem) selectedItem = props.navItems[0]
    return (
        <div className="HierarchyLeftNav">
            <Menu style={{ padding: 0, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor}}>
                {props.navItems.map((item, index) =>
                   {
                       const renderItemText = () => {
                           if (item.includes("positions"))
                               if (checkPositionFieldAvailable("plural")) {
                                   return accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel
                               }
                           return strings[item.replace(/^\w/, (c) => c.toUpperCase())]
                       }
                       return (
                           <MenuItem
                               data-intercom-target={`menu-Hierarchy-${strings[item.replace(/^\w/, (c) => c.toUpperCase())].split(" ").join("-")}`}
                               key={index}
                               primaryText={renderItemText()}
                               //className={selectedItem === item ? "filter-menu-selected" : "filter-menu"}
                               onClick={() => browserHistory.push(`/hierarchy/${item}`)}
                               style={{
                                   color: selectedItem === item ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuTextColor
                               }}
                           />
                       )
                   }
                )}
            </Menu>
        </div>
    )
}

export default HierarchyLeftNav
